<template>
  <v-app>
    <v-main>
      <div id="app">
        <router-view/>
      </div>

    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'app',

  data: () => ({
    //
  }),
};
</script>

<style lang="less">
*, *:before, *:after {
  box-sizing: border-box;
}
* {
  font-family: Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,
body{
  max-width: 100% !important;
  overflow-x: hidden !important;
  overscroll-behavior-x: none !important;
  

  ::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #f5f5f5;
  }
//chrome scrollbar
  ::-webkit-scrollbar { 
      width: 5px;
      background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #d6d6d6;
  }
}

html{
  height: -webkit-fill-available;
}
body{
  background-color: #ffffff;
  min-height: 100vh;
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;
}

#app {
  // text-align: center;
  color: #2c3e50;
}
</style>

